import React from 'react';
import SvgIcon from './SvgIcon';

const EmailSent = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M9.75 14.25v7.875l3.863-5.475"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M22.125 1.875L9.75 14.25m-8.625-3.375l21-9-3.375 18-9-5.625-8.625-3.375z"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

EmailSent.displayName = 'EmailSentIcon';

export default EmailSent;
